import React, { useEffect, useState } from "react";
import "./HotelsCards.css";
// import image from "../../assets/hotel2.jpg";
import { BsPinMapFill } from "react-icons/bs";
import { FaAddressCard } from "react-icons/fa";
// import { Link } from "react-router-dom";
import axios from "../../Utilities/axios";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import hotelplace from '../../assets/hotelplace.webp';
import { getHotelImage } from '../../assets/hotelImages';
import AOS from "aos";
import "aos/dist/aos.css";

const HotelsCards = () => {
  const [hotels, setHotels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigation = useNavigate();

  const getHotels = async () => {
    setIsLoading(true);
    const hotels = await axios.get(
      `/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`
    );
    setHotels(hotels.data);
    setIsLoading(false);
  };

  useEffect(() => {
    getHotels();
  }, []);

  const generateRandomCode = (length) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      code += characters.charAt(randomIndex);
    }

    return code;
  };

  const passDetails = (hotel) => {
    const randomCode = generateRandomCode(20);
    const hotelId = hotel.hotelId;
    const hotelName = hotel.hotelName;
    navigation(`/hotel-rooms/${hotelId}/${randomCode}`, { state: { hotel } });
  };

  // console.log("hotels", hotels)

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <div className='container'>
        <div className='rest__headStyle'>
          <div
            className='text-hero-bold'
            style={{ fontSize: "1.2em", fontWeight: "600" }}
          >
            Residency Hotels
            <hr />
          </div>
          <div className='text-hero-regular'>
            Residency Room is designed for luxury and comfort, with the state of
            art funitures that suites your class
          </div>
        </div>
        <div className='row'>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RotatingLines
                strokeColor='grey'
                strokeWidth='4'
                animationDuration='0.75'
                width='86'
                visible={true}
              />
            </div>
          ) : (
            hotels &&
            hotels.map((hotel, i) => (
              <div
                className='col-md-4 hotelCardImg '
                data-aos='fade-up'
                key={i}
              >
                <div
                  className='card mt-3 mb-3 hotelCardImg'
                  style={{ height: "91%" }}
                  data-aos='flip-up'
                >
                  <img
                    src={hotel.picture}
                    onError={(e) => {
                      const match = getHotelImage(hotel.hotelName);
                      if (match && e.target.src !== match) {
                        e.target.src = match;
                      } else {
                        e.target.src = hotelplace;
                      }
                    }}
                    className='card-img-top hotelCardImg'
                    alt='...'
                  />
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-8'>
                        <h5
                          className='card-title pb-2'
                          style={{ fontSize: "1em", fontWeight: "600" }}
                        >
                          {hotel.hotelName} <br />{" "}
                          <span
                            style={{ fontSize: "0.7em", fontWeight: "400" }}
                          >
                            {" "}
                            <BsPinMapFill
                              style={{
                                fontSize: "1em",
                                fontWeight: "400",
                                color: "#6265B4",
                              }}
                            />{" "}
                            <span
                              style={{ color: "#6265B4", marginLeft: "2%" }}
                            >
                              {" "}
                              {hotel.location}{" "}
                            </span>
                          </span>{" "}
                        </h5>
                      </div>
                      <div className='col-md-4'>
                        <p
                          className='card-text'
                          style={{ fontWeight: "600", color: "#2E2D90" }}
                        >
                          &#8358;{hotel.hotelMinimumPrice.toLocaleString()}{" "}
                          <span
                            className='perNight'
                            style={{ fontSize: "0.6em", color: "black" }}
                          >
                            / night
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className=' col-md-12 '>
                      <p style={{ fontSize: "0.7em", fontWeight: "400" }}>
                        {" "}
                        <FaAddressCard
                          style={{
                            fontSize: "1.3em",
                            fontWeight: "400",
                            color: "#6265B4",
                          }}
                        />{" "}
                        <span style={{ color: "#6a6f86", marginLeft: "2%" }}>
                          {" "}
                          {hotel.address}{" "}
                        </span>
                      </p>{" "}
                    </div>

                    <p
                      className='card-text pb-2'
                      style={{
                        fontSize: "0.8em",
                        fontWeight: "200",
                        opacity: "0.5",
                        overflow: "hidden",
                        height: "25%",
                      }}
                    >
                      {hotel.shortHotelDescription}
                    </p>

                    <div className='container'>
                      <div className='row'>
                        <div className='card-text'>
                          <small
                            class='text-body-secondary'
                            style={{ fontSize: "0.6em", fontWeight: "200" }}
                          >
                            <ul className='list-group list-group-horizontal mb-3'>
                              <li className='list-group-item '>Pool</li>
                              <li className='list-group-item '>Free Wifi</li>
                              <li className='list-group-item '>Event center</li>
                              <li className='list-group-item '>Bush bar</li>
                            </ul>
                          </small>
                        </div>
                      </div>
                    </div>

                    {/* <Link to='/selectroom'> */}
                    <p className='card-text'>
                      <small className='text-muted'>
                        <button
                          className='btn btn-primary col-md-12 p-1 buttnTxt'
                          onClick={() => passDetails(hotel)}
                        >
                          Book Now
                        </button>
                      </small>
                    </p>
                    {/* </Link> */}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default HotelsCards;
